import { render, staticRenderFns } from "./TreatmentDentalDetails.vue?vue&type=template&id=7c3b3802&scoped=true"
import script from "./TreatmentDentalDetails.vue?vue&type=script&lang=js"
export * from "./TreatmentDentalDetails.vue?vue&type=script&lang=js"
import style0 from "./TreatmentDentalDetails.vue?vue&type=style&index=0&id=7c3b3802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3b3802",
  null
  
)

export default component.exports